// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604070903/js/" + chunkId + "." + {"44":"7e0c8ccd","225":"b85d60a4","481":"af9be016","486":"c62b1c76","770":"10266c3b"}[chunkId] + ".0.6166473186729984.chunk.js";
};